import { VerseIdBibleReference } from '../types/reference';
import { VerseReference } from '../types/verse';
import { getBibleBookById } from './books';
import { parseBibleVerseId } from './verseId';
import { getBibleVersionById } from './versions';

export const formatBibleReference = (reference?: VerseIdBibleReference): string => {
  if (reference === undefined) {
    return '';
  }

  try {
    const startVerse = parseBibleVerseId(reference.startVerseId);
    const endVerse = parseBibleVerseId(reference.endVerseId);

    return formatVerseReference(startVerse, endVerse, reference.version);
  } catch (error) {
    return '';
  }
};

export const formatVerseReference = (
  startVerse: VerseReference,
  endVerse: VerseReference,
  versionId: string
): string => {
  const book = getBibleBookById(startVerse.bookId)?.label ?? '';
  const version = getBibleVersionById(versionId)?.abbreviation ?? '';

  // Note: We don't permit users to create a range across books
  // Note: We don't permit users to enter verse numbers when a chapter range is entered

  if (startVerse.chapter !== endVerse.chapter) {
    // Genesis 1-2 (ESV)
    return `${book} ${startVerse.chapter}-${endVerse.chapter} (${version})`;
  }

  if (startVerse.verse === endVerse.verse) {
    // Genesis 1:1 (ESV)
    return `${book} ${startVerse.chapter}:${startVerse.verse} (${version})`;
  }

  if (startVerse.verse === 0) {
    // Genesis 1 (ESV)
    return `${book} ${startVerse.chapter} (${version})`;
  }

  // Genesis 1:1-10 (ESV)
  return `${book} ${startVerse.chapter}:${startVerse.verse}-${endVerse.verse} (${version})`;
};
